import type { DayKey, BusinessHours } from "@/components/BusinessHours/types";
import { BUSINESS_HOURS_DAY_KEYS } from "@/components/BusinessHours/types";
import type { QRProps } from "@/contexts/QREditorContext/types";
import type { LocationType } from "@/features/previews/shared/components/PreviewLocationBlock";
import { getFullAddress } from "@/utils/qrEditorHelper";

export const OPENING_HOURS_DAY_TRANSLATION_KEYS: Record<DayKey, string> = {
  monday: "preview_opening_hours_monday",
  tuesday: "preview_opening_hours_tuesday",
  wednesday: "preview_opening_hours_wednesday",
  thursday: "preview_opening_hours_thursday",
  friday: "preview_opening_hours_friday",
  saturday: "preview_opening_hours_saturday",
  sunday: "preview_opening_hours_sunday",
};

export const buildAddressData = (data: QRProps<"business">["data"] | undefined): LocationType => {
  if (!data) {
    return {
      address: "",
      city: "",
      country: "",
      numeration: "",
      state: "",
      zipCode: "",
      fullAddress: "",
    };
  }

  const { address, numeration, city, zipCode, state, country } = data;
  const fullAddress = getFullAddress(address, numeration, city, zipCode, state, country);

  return {
    address,
    city,
    country,
    numeration,
    state,
    zipCode,
    fullAddress,
  };
};

export const hasEnabledBusinessHours = (businessHours?: BusinessHours): boolean => {
  if (!businessHours) {
    return false;
  }

  return Object.values(businessHours.days).some((day) => day?.enabled);
};

export const getEnabledBusinessDays = (businessHours: BusinessHours): DayKey[] => {
  return BUSINESS_HOURS_DAY_KEYS.filter((day) => businessHours.days[day]?.enabled);
};

export const hasBusinessContactInfo = (data?: QRProps<"business">["data"]): boolean => {
  if (!data) {
    return false;
  }

  return Boolean(data.contactName || data.contactPhone || data.contactEmail || data.contactWebsite);
};
